export type SlackChannelsList = {
  team_id: string;
  channels: SlackChannel[];
};

export type SlackChannel = {
  name: string;
  id: string;
};

export type SelectedChannelsChangedEvent = CustomEvent<{
  teamId: string;
  selectedChannels: SlackChannel[];
}>;

export type SlackChannelListError = {
  status;
  type;
  error;
};

export enum SlackAuthProblem {
  NoSlackAuthException = `NoSlackAuthException`,
  MissingSlackAuthScopesException = `MissingSlackAuthScopesException`,
}
